export const GET_BOOKS = 'GET_BOOKS'
export const NOT_FOUND = 'NOT_FOUND'
export const RESET_BOOKS = 'RESET_BOOKS'
export const GET_BOOK = 'GET_BOOK'
export const START_LOADING = 'START_LOADING'
export const FINISH_LOADING = 'FINISH_LOADING'
